// TimelineDependencyOverlay.jsx

import React, { useMemo } from 'react';

import { buildTimelineDependencyPaths } from 'views/timeline/views/shared/timelineViewUtils';

import './TimelineDependencyOverlay.css';

/**
 * SVG overlay for Gantt-style predecessor connectors.
 */
const TimelineDependencyOverlay = React.memo(({
  barItems = [],
  visible = false,
  stroke = 'currentColor',
}) => {
  const paths = useMemo(
    () => (visible ? buildTimelineDependencyPaths(barItems) : []),
    [barItems, visible],
  );

  if (!visible || paths.length === 0) return null;

  return (
    <svg
      className="timeline-dependency-overlay"
      aria-hidden="true"
    >
      {paths.map((path) => (
        <path
          key={path.key}
          className="timeline-dependency-overlay-path"
          d={path.d}
          fill="none"
          stroke={stroke}
          strokeWidth="1.5"
          markerEnd="url(#timeline-dep-arrow)"
        />
      ))}
      <defs>
        <marker
          id="timeline-dep-arrow"
          markerWidth="8"
          markerHeight="8"
          refX="6"
          refY="3"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M0,0 L6,3 L0,6 Z" fill={stroke} />
        </marker>
      </defs>
    </svg>
  );
});

TimelineDependencyOverlay.displayName = 'TimelineDependencyOverlay';

export default TimelineDependencyOverlay;
